import $ from 'jquery';
import fetch from 'utils/fetch';
import debounce from 'lodash.debounce';
import React from 'react';
import ReactDOM from 'react-dom';
import _debug from 'debug';
import BillDetail from 'saas/common/bill/BillDetail';
import DocumentList from './components/DocumentList';
import { hideLoader } from 'plugins/loader';
import { renderList, columnWidth } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';
import * as standardSettings from 'modules/saas/settings/standard/edit';
import RefEditor from 'saas/common/references/RefEditor';

require('plugins/are-you-sure');

export function index() {
  refreshNextInvoiceValue();
  $('#invoicePrefix').on('keyup', debounce(refreshNextInvoiceValue, 500));

  refreshNextEstimateValue();
  $('#estimatePrefix').on('keyup', debounce(refreshNextEstimateValue, 500));
}

export function tva() {
  $('.checkbox.tva-default').on('click', evt => {
    const id = $(evt.target)
      .closest('.checkbox.tva-default')
      .data('id');
    fetch(`/pco-manager/settings/tva/${id}/setDefault`, {
      method: 'POST',
    }).then(_ => {
      location.reload();
    });
  });
}

function refreshNextInvoiceValue() {
  const $nextValue = $('#nextInvoiceValue');
  const prefix = $('#invoicePrefix').val();

  fetch(`/pco-manager/settings/invoice/${prefix}`)
    .then(res => res.text())
    .then(value => {
      $nextValue.text(value);
    });
}

function refreshNextEstimateValue() {
  const $nextValue = $('#nextEstimateValue');
  const prefix = $('#estimatePrefix').val();

  fetch(`/pco-manager/settings/estimate/${prefix}`)
    .then(res => res.text())
    .then(value => {
      $nextValue.text(value);
    });
}

const debug = _debug('app::lines');

const handleFormSubmission = getData => {
  const $form = $('section.settings form.mainForm');

  $('.actionBar button[type=submit]').on('click', function(evt) {
    evt.preventDefault();
    $form.trigger('submit');
  });

  $form.on('submit', evt => {
    evt.preventDefault();

    $form.removeClass('submit').removeClass('dirty');

    // Submitting
    const url = $form.attr('action');
    const data = getData();

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then(
      res => window.location.replace(res.url),
      err => {
        console.log('Error attempting to save models', err);

        hideLoader();
      }
    );

    return false;
  });
};

export function lines(ctx) {
  const root = document.getElementById('lines');
  if (root) {
    debug(`Rendering line models settings`);

    const $form = $('section.settings form.mainForm');
    const lines = __INITIAL_DATA__ || [];

    const onChange = () => $form.addClass('dirty');

    const linesComponent = ReactDOM.render(
      <BillDetail lines={lines} noTotal isModel onChange={onChange} />,
      root
    );

    const getData = () => ({
      lines: linesComponent.getLines(),
      deletedIds: linesComponent.state.deletedIds,
    });

    handleFormSubmission(getData);
  }

  return null;
}

export function annexTemplateList() {
  const from = '/pco-manager/settings/annex-activities';

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/settings/annex-activities/${id}`, from);
  const loadNextUrl = '/pco-manager/settings/annex-activities.json';

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
  const $checkboxes = $('.checkbox.template-status');

  if ($checkboxes && $checkboxes.length) {
    $checkboxes.off('click').on('click', evt => {
      evt.stopPropagation();
      const $elem = $(evt.target);
      const $id = $elem.data('id');
      fetch(`/pco-manager/settings/annex-activities/${$id}/toggleEnabled`, {
        method: 'POST',
      }).then(
        res => window.location.replace(res.url),
        err => {
          console.log('Error attempting to toggle template enabled', err);

          hideLoader();
        }
      );
    });
  }
}

function renderTaskType({ cellData }) {
  switch (cellData) {
    case 'ANNEX_1':
      return 'Activité 1';
    case 'ANNEX_2':
      return 'Activité 2';
    default:
      return 'Inconnue';
  }
}

function renderActivated({ cellData, rowData }) {
  let label, title;

  switch (cellData) {
    case true:
      label = 'ui green labels';
      title = 'Activé';
      break;
    case false:
      label = 'ui labels';
      title = 'Désactivé';
      break;
    default:
      break;
  }

  const checked = rowData.activated ? { checked: 'checked' } : {};
  if (label && title) {
    return (
      <div className="ui grid">
        <div className="ui four wide column">
          <div
            className="ui fitted slider checkbox template-status"
            style={{ marginTop: '7px' }}
          >
            <input
              type="checkbox"
              name="default"
              data-id={rowData.id}
              {...checked}
              readOnly
            />
            <label />
          </div>
        </div>
        <div className="eight wide column">
          <div className={label}>
            <span className="ui label">{title}</span>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

function renderColumns(width) {
  return [
    <Column
      key="type"
      dataKey="type"
      cellRenderer={renderTaskType}
      disableSort
      width={columnWidth(width, 3)}
      label="Type"
    />,
    <Column
      key="label"
      dataKey="label"
      disableSort
      width={columnWidth(width, 9)}
      label="Nom"
    />,
    <Column
      key="activated"
      dataKey="activated"
      disableSort
      width={columnWidth(width, 4)}
      cellRenderer={renderActivated}
      label="Etat"
    />,
  ];
}

const editActivitySettings = () => {
  $('.task_template.help').popup({
    popup: '.task_template.popup',
    on: 'click',
    position: 'right center',
    lastResort: 'top left',
    offset: 0,
  });

  $('form.ui.form').areYouSure();

  const $root = $('.refRenderer');
  if ($root && $root.length) {
    // Retrieving context data
    const refs = __INITIAL_DATA__;

    const components = $root.map((_, elem) => {
      const $refContainer = $(elem);
      if (
        $refContainer &&
        $refContainer.length &&
        $refContainer.data('reftype')
      ) {
        const refType = $refContainer.data('reftype');
        const fieldPrefix = $refContainer.data('prefix');
        const buttonLabel = $refContainer.data('buttonlabel');
        const columnLabel = $refContainer.data('columnlabel');

        const refsToUse = refs.filter(
          r => r.reference_type === refType && r.deleted === false
        );

        return ReactDOM.render(
          <RefEditor
            buttonLabel={buttonLabel}
            columnLabel={columnLabel}
            lines={refsToUse}
            prefix={fieldPrefix}
            dirtyFormSupport
          />,
          elem
        );
      } else {
        return undefined;
      }
    });

    standardSettings.handleFormSubmission(components, true);
  }
};

export const otherPestsEdit = () => {
  // Enable dirty form
  $('form.ui.form').areYouSure();
  editActivitySettings();
};

export const ratEdit = () => {
  // Enable dirty form
  $('form.ui.form').areYouSure();
  editActivitySettings();
};

export const insectEdit = () => {
  // Enable dirty form
  $('form.ui.form').areYouSure();
  editActivitySettings();
};

export function documents(ctx) {
  const root = document.getElementById('documents');
  if (root) {
    debug(`Rendering document models settings`);

    const $form = $('section.settings form.mainForm');
    const documents = __INITIAL_DATA__ || [];

    const onChange = () => $form.addClass('dirty');

    const documentsComponent = ReactDOM.render(
      <DocumentList documents={documents} onChange={onChange} />,
      root
    );

    const getData = () => ({
      documents: documentsComponent.getDocuments(),
      deletedIds: documentsComponent
        .getDeletedIds()
        .map(id => parseInt(id, 10)),
    });

    handleFormSubmission(getData);
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/modules/saas/settings/index.js